import { useState } from "react";

export const useModalConfirm = () => {
  const [modalConfirm, setModalConfirm] = useState({
    show: false,
    title: "",
    description1: "",
    description2: "",
    question: "",
    variant: "light",
    titleColor: "secondary",
    buttonSize: "small",
    loading: false,
    leftButtonText: "Cancelar",
    leftButtonColor: "secondary",
    leftButtonVariant: "outlined",
    leftIconName: "",
    leftIconColor: "",
    leftIconColorHover: "",
    onClickLeft: null,
    rightButtonText: "Confirmar",
    rightButtonColor: "primary",
    rightButtonVariant: "contained",
    rightIconName: "",
    rightIconColor: "",
    rightIconColorHover: "",
    onClickRight: null,
    ethiquin: "inspector",
    inputLabel: "",
    inputValue: "",
    setInputValue: () => {},
    hasInvDescription: false,
  });

  const openModalConfirm = (config = {}) => {
    // functional update para evitar stale closure y mantener prevState
    setModalConfirm((prev) => ({ ...prev, ...config, show: true }));
  };

  const updateModalConfirm = (patch) => {
    // acepta objeto ó función
    setModalConfirm((prev) => {
      if (typeof patch === "function") {
        return { ...prev, ...patch(prev) };
      }
      return { ...prev, ...patch };
    });
  };

  const closeModalConfirm = () => {
    setModalConfirm((prev) => ({ ...prev, show: false }));
  };

  return {
    modalConfirm,
    openModalConfirm,
    updateModalConfirm,
    closeModalConfirm,
  };
};
